// Manejador global de errores para evitar errores en consola
export const setupErrorHandler = () => {
  // Manejar errores de WebSocket de Vite
  window.addEventListener('error', (event) => {
    // Filtrar errores de WebSocket de desarrollo
    if (event.message?.includes('WebSocket') && event.message?.includes('localhost:5173')) {
      event.preventDefault();
      return;
    }
    
    // Filtrar errores de share-modal.js (probablemente de extensión del navegador)
    if (event.filename?.includes('share-modal.js') || 
        event.message?.includes('share-modal') ||
        (event.error?.message?.includes('addEventListener') && event.filename?.includes('share-modal'))) {
      event.preventDefault();
      return;
    }
  });

  // Manejar errores no capturados de promesas
  window.addEventListener('unhandledrejection', (event) => {
    // Filtrar errores de WebSocket
    if (event.reason?.message?.includes('WebSocket')) {
      event.preventDefault();
      return;
    }
  });

  // Suprimir mensajes de Apollo DevTools en desarrollo
  const originalConsoleLog = console.log;
  console.log = (...args) => {
    if (args[0]?.includes?.('Download the Apollo DevTools')) {
      return;
    }
    originalConsoleLog.apply(console, args);
  };
}; 